import CircleIcon from "@mui/icons-material/Circle";
import { Box, useTheme } from "@mui/material";
import { orange } from "@mui/material/colors";

type ManifestDetailsTabHeaderProps = {
  manifestNeedsReview: boolean;
};

export function ManifestDetailsTabHeader({ manifestNeedsReview }: ManifestDetailsTabHeaderProps) {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" gap={theme.spacing(1)}>
      {manifestNeedsReview && <CircleIcon sx={{ color: orange[500], fontSize: "7px" }} />}
      Manifest Details
    </Box>
  );
}
